const LOCAL_AUTH_STORAGE_KEYS = ["user", "auth", "token"];
const SESSION_AUTH_STORAGE_KEYS = ["selectedWaterSystem"];

export const clearAuthCookie = (name = "v2Authenticated") => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const clearAuthState = ({ includeCookie = false } = {}) => {
  LOCAL_AUTH_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });

  SESSION_AUTH_STORAGE_KEYS.forEach((key) => {
    sessionStorage.removeItem(key);
  });

  localStorage.removeItem("route");

  if (includeCookie) {
    clearAuthCookie();
  }
};

export const buildRevokeUrl = (revokeBase, authParams, token) => (
  token && token !== "null"
    ? `${revokeBase}${authParams}&jwt=${token}`
    : `${revokeBase}${authParams}`
);